import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, Loader2, Gamepad2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState('working'); // working | ok | fail
  const [email, setEmail] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setState('fail'); return; }
    axios.get(`${API}/auth/verify-email`, { params: { token } })
      .then(r => { setEmail(r.data.email || ''); setState('ok'); })
      .catch(() => setState('fail'));
  }, [params]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-[#0A0A0C] border border-[#1E1E24] rounded-2xl p-8 text-center" data-testid="verify-email-card">
        <Gamepad2 className="w-8 h-8 text-[#06B6D4] mx-auto mb-4" />
        {state === 'working' && (
          <>
            <Loader2 className="w-8 h-8 text-[#06B6D4] mx-auto animate-spin mb-3" />
            <p className="text-zinc-400 text-sm">Verifying your email…</p>
          </>
        )}
        {state === 'ok' && (
          <>
            <CheckCircle2 className="w-10 h-10 text-emerald-400 mx-auto mb-3" data-testid="verify-success" />
            <h1 className="text-xl font-black text-white mb-2">Email verified!</h1>
            <p className="text-sm text-zinc-400 mb-6">{email && <><span className="text-white font-semibold">{email}</span> is confirmed. </>}Your account is active — log in and start building.</p>
            <Link to="/login"><Button className="w-full bg-[#06B6D4] text-black hover:bg-[#0891B2]" data-testid="verify-login-btn">Log in</Button></Link>
          </>
        )}
        {state === 'fail' && (
          <>
            <XCircle className="w-10 h-10 text-red-400 mx-auto mb-3" data-testid="verify-fail" />
            <h1 className="text-xl font-black text-white mb-2">Link invalid or already used</h1>
            <p className="text-sm text-zinc-400 mb-6">If you already verified, just log in. Otherwise request a new link from the login screen.</p>
            <Link to="/login"><Button className="w-full bg-[#06B6D4] text-black hover:bg-[#0891B2]">Go to Log in</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
